module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step2-pict01-full-63a813b42869050f8e6ab9354e5fb761.jpg";